import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/search.png'
import _imports_1 from '../../../assets/icons/add.png'


const _withScopeId = n => (_pushScopeId("data-v-c347a3da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-container" }
const _hoisted_3 = {
  key: 0,
  class: "search-area"
}
const _hoisted_4 = {
  key: 1,
  class: "sidebar-actions"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "chats" }, "Chats", -1))
const _hoisted_6 = { class: "chats-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]

import { useGetAllSessions, createNewSession } from "@/composables/aiChatFunctions"
import { useStore } from "vuex"
import { computed, ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'chatSidebar',
  emits: ['sessionChanged'],
  setup(__props, { emit: __emit }) {


const emit = __emit
const store = useStore()

const searchAreaDisplayed = ref(false)
const searchTerm = ref('')

const userProfile = computed(() => store.getters['user/userProfile']);
const selectedSession = computed(() => store.getters['ai/selectedSession']);
const { sessions, isLoadingSessions, getSessions } = useGetAllSessions(userProfile.value.uid)

const filteredSessions = computed(() => {
    if (searchTerm.value === '') {
        return sessions.value
    }
    return sessions.value.filter((session) => {
        return session.name.toLowerCase().includes(searchTerm.value.toLowerCase())
    })
})

const handleCreateNewSession = async () => {
    const newSession = await createNewSession(userProfile.value.uid)
    getSessions()
    emit('sessionChanged', newSession)
}

const sessionChanged = (session: any) => {
    emit('sessionChanged', session)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (searchAreaDisplayed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              onBlur: _cache[0] || (_cache[0] = ($event: any) => {searchTerm.value = ''; searchAreaDisplayed.value = false}),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchTerm).value = $event)),
              type: "text",
              placeholder: "Konuşmalarda Ara"
            }, null, 544), [
              [_vModelText, searchTerm.value]
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (searchAreaDisplayed.value = !searchAreaDisplayed.value)),
              class: "sidebar-action-icon",
              src: _imports_0,
              alt: "Search Chats"
            }),
            _createElementVNode("img", {
              onClick: handleCreateNewSession,
              class: "sidebar-action-icon",
              src: _imports_1,
              alt: "Add New Chat"
            })
          ])),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (!_unref(isLoadingSessions))
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSessions.value, (session) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => (sessionChanged(session)),
                  class: _normalizeClass({ 'selected': session.id === selectedSession.value?.id }),
                  key: session.id
                }, _toDisplayString(session.name), 11, _hoisted_8))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})